module.exports = __webpack_public_path__ + "img/6电线电缆期刊.3343494b.png";